import React, { Component } from "react";

import { Link } from "react-router-dom";

class TravelRequestCreateStep3 extends Component {
  renderStep(no, title, status, active, completed) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 12, flex: 1 }}>
        <div
          style={{
            width: 38,
            height: 38,
            borderRadius: "50%",
            background: completed ? "#10B981" : active ? "#1464E9" : "#EEF2F7",
            color: completed || active ? "#fff" : "#334155",
            textAlign: "center",
            lineHeight: "38px",
            fontWeight: 900,
          }}
        >
          {completed ? "✓" : no}
        </div>
        <div>
          <div style={{ fontWeight: 900, color: active ? "#1464E9" : "#334155" }}>
            {title}
          </div>
          <div style={{ fontSize: 12, color: completed ? "#10B981" : "#64748B" }}>
            {status}
          </div>
        </div>
      </div>
    );
  }

  renderInput(label, value) {
    return (
      <div>
        <label style={labelStyle}>{label}</label>
        <input value={value} readOnly style={inputStyle} />
      </div>
    );
  }

  renderSideRow(label, value) {
    return (
      <div style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 12, color: "#64748B", fontWeight: 800 }}>{label}</div>
        <div style={{ fontSize: 13, color: "#0F172A", fontWeight: 800, marginTop: 5 }}>
          {value}
        </div>
      </div>
    );
  }

  render() {
    const rows = [
      ["Anticipated Meal Expense / Meals", "650.00", "3,000.00"],
      ["Other Advances", "850.00", "3,900.00"],
      ["Foreign Currency", "450.00", "2,070.00"],
    ];

    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 22 }}>
          <h3 style={{ margin: 0, color: "#0F172A", fontWeight: 900 }}>
            Create Travel Request
          </h3>
          <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
            Step 3 of 5 · Cash Advance
          </p>
        </div>

        <div style={stepWrapper}>
          {this.renderStep(1, "Traveler & Trip Details", "Completed", false, true)}
          {this.renderStep(2, "Schedule & Accommodation", "Completed", false, true)}
          {this.renderStep(3, "Cash Advance", "In Progress", true, false)}
          {this.renderStep(4, "Documents", "Pending", false, false)}
          {this.renderStep(5, "Review & Submit", "Pending", false, false)}
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 420px", gap: 22 }}>
          <div>
            <div style={card}>
              <h4 style={sectionTitle}>1. Travel Cash Advance</h4>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 28 }}>
                <div>
                  <label style={labelStyle}>Corporate credit card provided?</label>
                  <div style={toggleGroup}>
                    <button style={toggleInactive}>Yes</button>
                    <button style={toggleActive}>No</button>
                  </div>
                </div>

                <div>
                  <label style={labelStyle}>Cash advance request?</label>
                  <div style={toggleGroup}>
                    <button style={toggleActive}>Yes</button>
                    <button style={toggleInactive}>No</button>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: 24 }}>
                <label style={labelStyle}>2. Reason for Cash Advance</label>
                <textarea
                  value="Transportation and meals during the Simpleview Summit 2023 in Houston, Texas."
                  readOnly
                  rows={4}
                  style={textareaStyle}
                />
                <div style={{ textAlign: "right", fontSize: 12, color: "#64748B", marginTop: -22, paddingRight: 10 }}>
                  73 / 500
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "360px 1fr", gap: 18, marginTop: 20 }}>
                <div style={innerCard}>
                  <h4 style={sectionTitle}>3. Cash Advance Checklist</h4>

                  <label style={labelStyle}>Travel Type</label>
                  <div style={{ display: "flex", gap: 24, marginBottom: 16 }}>
                    <label style={radioLabel}><input type="radio" readOnly /> Domestic Travel</label>
                    <label style={radioLabel}><input type="radio" checked readOnly /> International Travel</label>
                  </div>

                  <div style={infoBox}>
                    Submission must be at least:
                    <ul style={{ margin: "8px 0 0", paddingLeft: 18 }}>
                      <li>Minimum 7 working days for domestic travel</li>
                      <li>Minimum 10 working days for international travel</li>
                    </ul>
                  </div>

                  <label style={labelStyle}>Submitted previous cash advance claim?</label>
                  <div style={toggleGroupSmall}>
                    <button style={toggleActive}>Yes</button>
                    <button style={toggleInactive}>No</button>
                  </div>

                  <label style={{ ...labelStyle, marginTop: 16 }}>Are there unusual circumstances?</label>
                  <div style={toggleGroupSmall}>
                    <button style={toggleActive}>Yes</button>
                    <button style={toggleInactive}>No</button>
                  </div>

                  <div style={{ marginTop: 16 }}>
                    <label style={labelStyle}>Explanation</label>
                    <textarea
                      value="Annual leave from 28–29 April 2023 reduces the travel lead time."
                      readOnly
                      rows={4}
                      style={textareaStyle}
                    />
                  </div>
                </div>

                <div style={innerCard}>
                  <h4 style={sectionTitle}>4. Cash Advance Request</h4>

                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#F8FAFC" }}>
                        {["Description", "Foreign Currency (USD)", "Amount (RM)", ""].map((h) => (
                          <th key={h} style={thStyle}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={index} style={{ borderTop: "1px solid #E5E7EB" }}>
                          <td style={tdStyle}>
                            <div style={{ fontWeight: 900 }}>{row[0]}</div>
                            <div style={{ fontSize: 11, color: "#64748B", marginTop: 3 }}>
                              {index === 0 ? "7 nights in Houston" : index === 1 ? "Taxi, hotel deposit & contingencies" : "Cash for incidental expenses"}
                            </div>
                          </td>
                          <td style={tdStyle}>
                            <input value={row[1]} readOnly style={{ ...tableInput, textAlign: "right" }} />
                          </td>
                          <td style={tdStyle}>
                            <input value={row[2]} readOnly style={{ ...tableInput, textAlign: "right", fontWeight: 900 }} />
                          </td>
                          <td style={tdStyle}>
                            <button style={deleteButton}>🗑</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <button style={{ ...secondaryButton, width: "100%", marginTop: 14 }}>
                    + Add Line Item
                  </button>

                  <div style={summaryBar}>
                    <div>
                      <div style={{ fontWeight: 900 }}>Exchange Rate (USD → RM)</div>
                      <div style={{ fontSize: 12, color: "#64748B", marginTop: 4 }}>
                        1 USD = 4.60 RM (Sample)
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ color: "#64748B", fontSize: 12, fontWeight: 800 }}>
                        Total Advance Request
                      </div>
                      <div style={{ fontSize: 24, fontWeight: 900, color: "#0F172A" }}>
                        RM 8,970.00
                      </div>
                    </div>
                  </div>

                  <div style={infoBox}>
                    Any unspent amount must be fully settled and reflected in your claim.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div style={card}>
              <h4 style={sectionTitle}>5. Per Day Claim Policy Reference</h4>
              <p style={{ color: "#64748B", fontSize: 13 }}>
                Example – Per Day Claim (International). Amounts in RM.
              </p>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#F8FAFC" }}>
                    {["Location", "Non-Exec", "Exec/Mngr", "Middle Mgmt", "Senior Mgmt", "Top Mgmt"].map((h) => (
                      <th key={h} style={policyTh}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["Within Malaysia", 65, 80, 115, 125, 135],
                    ["Southeast Asia", 180, 200, 220, 240, 260],
                    ["Singapore & Brunei", 200, 220, 240, 260, 280],
                    ["Asia Pacific", 240, 260, 280, 300, 320],
                    ["Europe & America", 255, 280, 320, 340, 360],
                  ].map((r) => (
                    <tr key={r[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                      {r.map((c) => (
                        <td key={c} style={policyTd}>{c}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>

              <div style={{ ...infoBox, marginTop: 14 }}>
                Actual claim will be based on receipts and eligible expenses per policy.
              </div>
            </div>

            <div style={{ ...card, background: "#FFF7E6", borderColor: "#FED7AA" }}>
              <h4 style={sectionTitle}>Process Guidance</h4>
              <p style={{ color: "#92400E", fontSize: 13, lineHeight: "22px" }}>
                Finance may reject payment if the submission is less than the required time frame
                unless unusual circumstances apply.
              </p>
              <div style={{ height: 1, background: "#FED7AA", margin: "14px 0" }} />
              <div style={{ fontWeight: 900, color: "#0F172A", marginBottom: 8 }}>
                Required Submission Lead Time
              </div>
              <ul style={{ color: "#92400E", fontSize: 13, lineHeight: "22px", paddingLeft: 18 }}>
                <li>Domestic Travel: minimum 7 working days</li>
                <li>International Travel: minimum 10 working days</li>
              </ul>
            </div>
          </div>
        </div>

        <div style={footerBar}>
          <Link to="/travel/create/step-2" style={secondaryButtonLink}>
            ← Back
          </Link>
          <div style={{ display: "flex", gap: 12 }}>
            <button style={secondaryButton}>Save Draft</button>
            <Link to="/travel/create/step-4" style={primaryButtonLink}>
              Next →
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const stepWrapper = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 22,
  display: "flex",
  gap: 18,
  marginBottom: 18,
};

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 20,
  marginBottom: 16,
};

const innerCard = {
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
};

const sectionTitle = {
  margin: "0 0 16px",
  color: "#0F172A",
  fontWeight: 900,
};

const labelStyle = {
  display: "block",
  fontSize: 13,
  fontWeight: 800,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 40,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
};

const textareaStyle = {
  width: "100%",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: 12,
  fontSize: 13,
  color: "#334155",
  resize: "vertical",
};

const toggleGroup = {
  display: "inline-flex",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  overflow: "hidden",
};

const toggleGroupSmall = {
  ...toggleGroup,
  marginBottom: 4,
};

const toggleActive = {
  background: "#082044",
  color: "#fff",
  border: 0,
  padding: "9px 32px",
  fontWeight: 900,
};

const toggleInactive = {
  background: "#fff",
  color: "#334155",
  border: 0,
  padding: "9px 32px",
  fontWeight: 800,
};

const radioLabel = {
  display: "flex",
  gap: 8,
  alignItems: "center",
  fontSize: 13,
  color: "#334155",
};

const infoBox = {
  background: "#EAF3FF",
  border: "1px solid #BFDBFE",
  borderRadius: 8,
  padding: 12,
  color: "#334155",
  fontSize: 13,
  lineHeight: "22px",
};

const thStyle = {
  padding: "12px",
  textAlign: "left",
  fontWeight: 900,
  fontSize: 12,
  color: "#334155",
};

const tdStyle = {
  padding: 10,
  fontSize: 13,
  color: "#334155",
  verticalAlign: "top",
};

const tableInput = {
  width: "100%",
  height: 36,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 10px",
  fontSize: 13,
};

const deleteButton = {
  border: "1px solid #E5E7EB",
  background: "#fff",
  borderRadius: 6,
  width: 32,
  height: 32,
};

const summaryBar = {
  background: "#F8FAFC",
  borderRadius: 10,
  padding: 16,
  marginTop: 16,
  display: "flex",
  justifyContent: "space-between",
};

const policyTh = {
  padding: 10,
  fontSize: 11,
  fontWeight: 900,
  color: "#334155",
  textAlign: "left",
};

const policyTd = {
  padding: 10,
  fontSize: 12,
  color: "#334155",
  borderTop: "1px solid #E5E7EB",
};

const footerBar = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginTop: 18,
  display: "flex",
  justifyContent: "space-between",
};

const primaryButton = {
  background: "#1464E9",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "12px 28px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "11px 24px",
  fontWeight: 800,
};

const primaryButtonLink = {
  ...primaryButton,
  textDecoration: "none",
  display: "inline-block",
};

const secondaryButtonLink = {
  ...secondaryButton,
  textDecoration: "none",
  display: "inline-block",
};


export default TravelRequestCreateStep3;